import {Component, OnInit, ViewChild, Renderer2, Input} from '@angular/core';
import {RestApiService} from '../rest-api.service';
import {MessageService} from '../message.service';
import {Router} from '@angular/router';
import {NotifierService} from 'angular-notifier';

@Component({
    selector: 'app-asset-search',
    templateUrl: './asset-search.component.html',
    styleUrls: ['./asset-search.component.css']
})
export class AssetSearchComponent implements OnInit {
    dataset = {};
    totalData: number;
    selectedTitles: any[];
    gridObj: any;
    show: boolean;
    selected: number;
    private notifier: NotifierService;
    respObject: any;
    private clientId: number;
    masterNameSelected: number;
    columnNameSelected: number;
    masterNameObj = [];
    columnDataObj = [];
    columnValueObj = [];
    columnValueObjBackup = [];
    masterName: string;
    assetValue: string;
    columnName: string;
    columVal: string;
    descId: number;
    attrValue = [];
    collectionSize: number;
    attrVal: string;
    page: number;
    pageSize: number;
    user_id: string;
    columnObj = [];
    recordId: number;
    editData = {};
    idValObj = {};
    updateData = {};

    @ViewChild('content') private content;
    @Input() ticketId: string;
    dataLoaded: boolean;

    constructor(private _rest: RestApiService, private messageService: MessageService,
                private route: Router, notifier: NotifierService, private renderer: Renderer2) {
        this.notifier = notifier;
    }

    ngOnInit() {
        this.page = 1;
        this.pageSize = 10;
        this.dataLoaded = true;
        this._rest.getUserdetails(this.messageService.getUserId()).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.clientId = this.respObject.details[0].clientId;
                // ======================================= get asset master data =============================================
                this._rest.getAssetManagementMaster(this.clientId).subscribe((res1) => {
                    this.respObject = res1;
                    if (this.respObject.success) {
                        this.masterNameObj = this.respObject.details;
                        this.masterNameObj.unshift({id: 0, masterName: 'Select asset master name'});
                        this.totalData = this.masterNameObj.length;
                    } else {
                        this.notifier.notify('error', this.respObject.errorMessage);
                    }
                }, (err) => {
                    this.notifier.notify('error', this.messageService.SERVER_ERROR);
                });
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });

        this.masterNameSelected = 0;
        this.columnNameSelected = 0;
        this.assetValue = '';
    }

    handleSelectedRowsChanged(e, args) {
        if (Array.isArray(args.rows)) {
            this.selectedTitles = args.rows.map(idx => {
                const item = this.gridObj.getDataItem(idx);
                return item || '';
            });

            if (this.selectedTitles.length > 0) {
                this.show = true;
                this.selected = this.selectedTitles.length;
            } else {
                this.show = false;
            }
            // console.log(JSON.stringify(this.selectedTitles));
        }
    }


    deleteAssetRecord(recordId) {
        if (this.columnValueObj.length === 0) {
            this.notifier.notify('error', 'No Asset to Delete.');
            return;
        }
        if (confirm('Are you sure?')) {
            this._rest.deleteAssetDescription({id: recordId, user_id: this.messageService.getUserId()}).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    this.totalData = this.totalData - 1;
                    this.notifier.notify('success', 'record delete successfully');
                    this.columnValueObj = [];
                    this.updateData = {};
                } else {
                    this.notifier.notify('error', this.respObject.errorMessage);
                }
            }, (err) => {
                this.notifier.notify('error', JSON.stringify(err));
            });
        }
    }

    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }

    editAssetRecord(recordId) {
        this.dataLoaded = false;
        if (this.columnValueObj.length === 0) {
            this.notifier.notify('error', 'No Asset to Update.');
            return;
        }
        const valueObj = {};
        for (const i in this.columnValueObj) {
            if (this.columnValueObjBackup[i].assetValue !== this.columnValueObj[i].assetValue) {
                valueObj[this.columnValueObj[i].columnId] = this.columnValueObj[i].assetValue;
            }

        }
        // console.log(valueObj);
        this.updateData['columnValueObj'] = valueObj;
        this.updateData['descriptionId'] = recordId;
        this.updateData['ticketId'] = this.ticketId;
        this.updateData['createdBy'] = this.messageService.getUserId();
        // console.log(this.updateData);
        this._rest.editAssetValue(this.updateData).subscribe((res) => {
            this.respObject = res;
            this.dataLoaded = true;
            if (this.respObject.success) {
                this.notifier.notify('success', 'record update successfully');
                this.columnValueObj = [];
                this.updateData = {};
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }


    editAssetRecord_old(recordId) {
        for (const i in this.dataset) {
            if (i !== 'id') {
                this.editData[i] = (<HTMLInputElement>document.getElementById(i)).value;
            }
        }

        for (const j in this.idValObj) {
            this.updateData[this.idValObj[j]] = this.editData[j];
        }
        this.updateData['descriptionId'] = recordId;
        this.updateData['createdBy'] = this.messageService.getUserId();
        this._rest.editAssetValue(this.updateData).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.notifier.notify('success', 'record update successfully');
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    onMasterChange(value: any) {
        this.masterName = this.masterNameObj[value].masterName;
        // =================================== get column name================================
        this._rest.getAssetColumnByMaster(this.clientId, this.masterNameSelected).subscribe((res) => {
            this.respObject = res;
            // console.log(this.respObject)
            if (this.respObject.success) {
                const data = this.respObject.details;
                this.columnDataObj = data;
                this.columnDataObj.unshift({columnId: 0, columnName: 'Select asset column name'});
                this.totalData = data.length;

            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
        // =============================================================================================================
    }

    onClientChange(value: any) {
        this.columnName = this.columnDataObj[value].columnName;
    }

    submitAssetData() {
        this.searchAssetmanagement();
    }

    searchAssetmanagement() {

        if (this.assetValue === '') {
            this.notifier.notify('error', 'Please enter a Asset ID.');
            return;
        }
        this.dataLoaded = false;
        this.columnValueObj = [];
        this.updateData = {};
        this._rest.maintainAssetManagementData(this.clientId, this.assetValue).subscribe((res) => {
            this.respObject = res;
            this.dataLoaded = true;
            if (this.respObject.success) {
                if (this.respObject.details.length === 0) {
                    this.notifier.notify('error', 'Asset details with Asset ID ' + this.assetValue + ' is not found.');
                } else {
                    for (const detailsObj of this.respObject.details) {
                        if (detailsObj.validationValue) {
                            detailsObj.validationValue = JSON.parse(detailsObj.validationValue);
                        }
                    }
                    this.columnValueObj = this.respObject.details;
                    this.columnValueObjBackup = JSON.parse(JSON.stringify(this.columnValueObj));
                    this.recordId = this.respObject.details[0].descriptionId;
                }

            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    searchAssetmanagement_old() {
        this._rest.maintainAssetManagementData(this.clientId, this.assetValue).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.columnValueObj = this.respObject.details;

                for (let j = 0; j < this.columnValueObj.length; j++) {
                    this.columVal = this.columnValueObj[j].columVal;
                    this.descId = this.columnValueObj[j].id;
                    const columnValue = this.columVal.split(',');
                    this.dataset['id'] = this.descId;
                    for (let k = 0; k < columnValue.length; k++) {
                        this.attrVal = columnValue[k];
                        this.attrValue = this.attrVal.split(':');
                        this.dataset[this.attrValue[1]] = this.attrValue[2];
                        this.idValObj[this.attrValue[1]] = this.attrValue[0];
                    }
                    this.collectionSize = this.columnValueObj[j].totalData;
                }
                // console.log('idvalobj=', JSON.stringify(this.idValObj));
                // =======================================================================
                document.getElementById('tbody').innerHTML = '';
                const container = document.getElementById('tbody');
                for (const i in this.dataset) {
                    if (i === 'id') {
                        this.recordId = this.dataset[i];
                    } else {
                        const tr = document.createElement('tr');
                        const td1 = document.createElement('td');
                        td1.innerText = i;
                        const td2 = document.createElement('td2');
                        const input = document.createElement('input');
                        input.className = 'form-control';
                        input.setAttribute('type', 'type');
                        input.setAttribute('value', this.dataset[i]);
                        input.setAttribute('name', i);
                        input.id = i;
                        td2.appendChild(input);
                        tr.appendChild(td1);
                        tr.appendChild(td2);
                        container.appendChild(tr);
                    }
                }
                // const tr1 = document.createElement('tr');
                // const td3 = document.createElement('td');
                // const button1 = document.createElement('button');
                // button1.innerText = 'Update';
                // this.renderer.listen(button1, 'click', (event) => {
                //   this.editAssetRecord(this.recordId);
                // });
                // const td4 = document.createElement('td');
                // const button2 = document.createElement('button');
                // button2.innerText = 'Delete';
                // this.renderer.listen(button2, 'click', (event) => {
                //   this.deleteAssetRecord(this.recordId);
                // });
                // td3.appendChild(button1);
                // td4.appendChild(button2);
                // tr1.appendChild(td3);
                // tr1.appendChild(td4);
                // container.appendChild(tr1);
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }
}
